import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffectWithPayload } from 'src/infrastructure/saga.helpers'
import {
  GetPreQueuePayload,
  LastUpdatedInfo,
  PreQueue,
  PreQueueInvoicesPayloadSagas,
  SupplierState,
  ValidateBilletBarcodePayloadSagas,
  ValidateExternalPurchaseOrderCodePayload,
} from './SupplierTypes'

const initialState: SupplierState = {
  preQueueItems: [],
  preQueueDeletedItems: [],
  lastUpdatedInfo: {
    dateOrMessage: 'Carregando...',
    error: '',
  },
}

const getPreQueue = justForSideEffectWithPayload<GetPreQueuePayload>()
const releasePreQueueInvoices = justForSideEffectWithPayload<PreQueueInvoicesPayloadSagas>()
const removePreQueueInvoices = justForSideEffectWithPayload<PreQueueInvoicesPayloadSagas>()
const validateBilletBarcode = justForSideEffectWithPayload<ValidateBilletBarcodePayloadSagas>()
const validateExternalPurchaseOrderCode = justForSideEffectWithPayload<ValidateExternalPurchaseOrderCodePayload>()

const setPreQueueItems = (state: SupplierState, action: PayloadAction<PreQueue[]>) => ({
  ...state,
  preQueueItems: action.payload,
})

const setPreQueueDeletedItems = (state: SupplierState, action: PayloadAction<PreQueue[]>) => ({
  ...state,
  preQueueDeletedItems: action.payload,
})

const setLastUpdatedInfo = (state: SupplierState, action: PayloadAction<LastUpdatedInfo>) => ({
  ...state,
  lastUpdatedInfo: action.payload,
})

const clearState = () => initialState

const slice = createSlice({
  name: 'preQueue',
  initialState,
  reducers: {
    getPreQueue,
    setPreQueueItems,
    setPreQueueDeletedItems,
    clearState,
    releasePreQueueInvoices,
    validateBilletBarcode,
    removePreQueueInvoices,
    setLastUpdatedInfo,
    validateExternalPurchaseOrderCode,
  },
})

export default slice.reducer

export const { actions } = slice
